export const he = {
  app: { name: 'Markit', sub: 'ניהול לקוחות' },
  common: {
    save: 'שמירה',
    saving: 'שומר…',
    cancel: 'ביטול',
    close: 'סגירה',
    edit: 'עריכה',
    delete: 'מחיקה',
    add: 'הוספה',
    back: 'חזרה',
    confirm: 'אישור',
    search: 'חיפוש',
    loading: 'טוען…',
    retry: 'נסו שוב',
    all: 'הכל',
    none: 'אין',
    yes: 'כן',
    no: 'לא',
    justNow: 'עכשיו',
    download: 'הורדה',
    open: 'פתיחה',
    view: 'צפייה',
    actions: 'פעולות',
    notes: 'הערות',
    total: 'סה״כ',
    page: 'עמוד',
    of: 'מתוך',
    results: 'תוצאות',
    prev: 'הקודם',
    next: 'הבא',
    unknownError: 'אירעה שגיאה. הפעולה לא בוצעה.',
    loadError: 'לא ניתן לטעון את הנתונים',
    required: 'שדה חובה',
    optional: 'רשות',
    savedToast: 'השינויים נשמרו',
    deletedToast: 'נמחק',
  },
  nav: {
    main: 'ראשי',
    dashboard: 'לוח בקרה',
    customers: 'לקוחות',
    documents: 'כל המסמכים',
    invoices: 'מאגר חשבוניות',
    finance: 'גבייה ותזרים',
    automation: 'אוטומציה',
    review: 'ממתינים לבדיקה',
    agent: 'סוכן המייל',
    settings: 'הגדרות',
    logout: 'התנתקות',
    searchPlaceholder: 'חיפוש לקוח, ח.פ, מספר חשבונית…',
    menu: 'תפריט',
  },
  auth: {
    title: 'כניסה למערכת',
    email: 'אימייל',
    password: 'סיסמה',
    submit: 'כניסה',
    submitting: 'מתחבר…',
    sessionExpired: 'פג תוקף ההתחברות. יש להתחבר מחדש.',
  },
  enums: {
    customerStatus: { active: 'פעיל', inactive: 'לא פעיל', prospect: 'פוטנציאלי' },
    paymentTerms: {
      IMMEDIATE: 'תשלום מיידי',
      EOM_FIXED_DAY: 'שוטף + תאריך מוסכם',
      EOM_30: 'שוטף + 30',
      EOM_45: 'שוטף + 45',
      EOM_60: 'שוטף + 60',
    },
    docType: {
      quote: 'הצעת מחיר',
      tax_invoice: 'חשבונית מס',
      tax_invoice_receipt: 'חשבונית מס / קבלה',
      receipt: 'קבלה',
      credit_note: 'חשבונית זיכוי',
      delivery_note: 'תעודת משלוח',
      proforma: 'חשבון עסקה',
      other: 'מסמך אחר',
    },
    quoteStatus: { draft: 'טיוטה', sent: 'נשלחה', approved: 'אושרה', rejected: 'נדחתה', expired: 'פג תוקף' },
    paymentStatus: { paid: 'שולם', partial: 'שולם חלקית', open: 'פתוח', overdue: 'באיחור', cancelled: 'בוטלה (זיכוי)', not_applicable: '—' },
    source: { email: 'מייל', manual: 'העלאה ידנית', backfill: 'ייבוא היסטוריה', morning: 'מורנינג' },
    ingestionStatus: {
      processing: 'בעיבוד',
      matched: 'שויך אוטומטית',
      needs_review: 'ממתין לבדיקה',
      processed: 'שויך ידנית',
      duplicate: 'כפול',
      ignored: 'סונן',
      failed: 'נכשל',
    },
    allocation: { reference: 'לפי אסמכתא במסמך', amount_match: 'לפי סכום זהה', self: 'חשבונית מס/קבלה', manual: 'שיוך ידני' },
  },
  customers: {
    title: 'לקוחות',
    new: 'לקוח חדש',
    import: 'ייבוא מקובץ',
    searchPlaceholder: 'שם, ח.פ, טלפון, איש קשר, עיר…',
    filters: { status: 'סטטוס', terms: 'תנאי תשלום', balance: 'יתרה', outstanding: 'יש יתרה פתוחה', overdue: 'באיחור' },
    cols: {
      name: 'שם העסק',
      companyNumber: 'ח.פ / ע.מ',
      contact: 'איש קשר',
      phone: 'טלפון',
      terms: 'תנאי תשלום',
      lastInvoice: 'חשבונית אחרונה',
      totalInvoiced: 'סה״כ חויב',
      outstanding: 'יתרה פתוחה',
      status: 'סטטוס',
      lastActivity: 'פעילות אחרונה',
    },
    empty: { title: 'עדיין אין לקוחות', body: 'צרו לקוח ראשון או ייבאו את רשימת הלקוחות הקיימת מקובץ Excel.' },
    noResults: { title: 'לא נמצאו לקוחות', body: 'נסו לחפש לפי שם אחר, ח.פ או טלפון, או נקו את הסינון.' },
    branchOf: 'סניף של',
  },
  customerForm: {
    titleNew: 'לקוח חדש',
    titleEdit: 'עריכת פרטי לקוח',
    business: 'פרטי העסק',
    businessName: 'שם העסק',
    businessNameHint: 'כפי שמופיע בחשבוניות',
    companyNumber: 'ח.פ / ע.מ',
    noCompanyNumber: 'ללקוח אין ח.פ / ע.מ',
    companyNumberHint: 'מזהה ראשי לשיוך אוטומטי של מסמכים',
    checksumWarn: 'ספרת הביקורת אינה תקינה — ודאו שהמספר נכון',
    taxId: 'מספר עוסק / מזהה נוסף',
    contact: 'איש קשר ראשי',
    phone: 'טלפון',
    email: 'אימייל',
    website: 'אתר',
    status: 'סטטוס',
    parent: 'לקוח אם (לסניף / מחלקה)',
    noParent: 'ללא — לקוח עצמאי',
    commercial: 'תנאים מסחריים',
    terms: 'תנאי תשלום',
    paymentDay: 'יום התשלום בחודש העוקב',
    paymentDayHint: 'לדוגמה 10 = החשבונית משולמת ב־10 לחודש שאחרי חודש ההפקה',
    addresses: 'כתובות',
    addAddress: 'הוספת כתובת',
    notes: 'הערות',
    create: 'יצירת לקוח',
    duplicateTitle: 'ייתכן שהלקוח כבר קיים',
    duplicateBody: 'מצאנו לקוחות דומים במערכת. ודאו שאינכם יוצרים כפילות:',
    createAnyway: 'זה לקוח אחר — צור בכל זאת',
    openExisting: 'פתיחת הלקוח הקיים',
    created: 'הלקוח נוצר',
  },
  address: {
    label: 'שם הכתובת',
    labelPlaceholder: 'משרד ראשי / מחסן / סניף…',
    street: 'רחוב',
    number: 'מספר',
    city: 'עיר',
    postal: 'מיקוד',
    contact: 'איש קשר באתר',
    phone: 'טלפון',
    notes: 'הערות',
    primary: 'כתובת ראשית',
    makePrimary: 'הגדרה כראשית',
    deleteConfirm: 'למחוק את הכתובת?',
    empty: 'לא הוגדרו כתובות',
  },
  profile: {
    tabs: { overview: 'סקירה', details: 'פרטי העסק', quotes: 'הצעות מחיר', invoices: 'חשבוניות', delivery: 'תעודות משלוח', activity: 'פעילות' },
    upload: 'העלאת מסמך',
    importHistory: 'ייבוא היסטוריה מהמייל',
    totalInvoiced: 'סה״כ חויב',
    outstanding: 'יתרה פתוחה',
    overdue: 'מתוכה באיחור',
    invoices: 'חשבוניות',
    quotes: 'הצעות מחיר',
    lastActivity: 'פעילות אחרונה',
    primaryQuote: 'הצעת המחיר הראשית',
    noPrimaryQuote: 'לא הוגדרה הצעת מחיר ראשית',
    unbilled: 'תעודות משלוח שטרם חויבו',
    unallocated: 'תקבולים שלא שויכו לחשבונית',
    aliases: 'שמות נוספים לזיהוי אוטומטי',
    aliasesHint: 'שמות שבהם הלקוח מופיע על מסמכים. נלמדים אוטומטית כשאתם משייכים מסמך מתור הבדיקה.',
    addAlias: 'הוספת שם',
    branches: 'סניפים / מחלקות',
    includeBranches: 'כולל סניפים',
    deleteCustomer: 'מחיקת לקוח',
    deleteConfirm: 'למחוק את הלקוח? הפעולה אינה הפיכה.',
    recentDocs: 'מסמכים אחרונים',
  },
  docs: {
    title: 'מסמכים',
    cols: {
      type: 'סוג',
      number: 'מספר',
      date: 'תאריך',
      customer: 'לקוח',
      description: 'תיאור',
      amount: 'סכום',
      subtotal: 'לפני מע״מ',
      vat: 'מע״מ',
      total: 'סה״כ',
      status: 'סטטוס',
      payment: 'תשלום',
      due: 'לתשלום עד',
      open: 'יתרה',
      source: 'מקור',
      imported: 'יובא',
      address: 'כתובת אספקה',
      billed: 'חויב בחשבונית',
    },
    empty: { title: 'אין מסמכים להצגה', body: 'מסמכים שמתקבלים ממורנינג יופיעו כאן אוטומטית.' },
    primary: 'ראשית',
    setPrimary: 'הגדרה כהצעה ראשית',
    lineItems: 'פריטים',
    payments: 'תשלומים וזיכויים',
    paidBy: 'שולם באמצעות',
    paysFor: 'משויך לחשבוניות',
    noPayments: 'לא נרשמו תשלומים לחשבונית זו',
    allocate: 'שיוך לחשבונית',
    reassign: 'העברה ללקוח אחר',
    deleteConfirm: 'למחוק את המסמך מהמערכת? הקובץ המקורי במייל לא יימחק.',
    origin: 'מקור המסמך',
    openEmail: 'פתיחת המייל המקורי',
    noFile: 'לא צורף קובץ',
    notBilled: 'טרם חויבה',
    unbilledOnly: 'רק שטרם חויבו',
  },
  review: {
    title: 'ממתינים לבדיקה',
    sub: 'מסמכים שהסוכן לא הצליח לשייך בביטחון מלא. בחרו לקוח — והמערכת תלמד לפעם הבאה.',
    empty: { title: 'אין מסמכים שממתינים לבדיקה', body: 'כל המסמכים שהתקבלו שויכו ללקוחות.' },
    detected: 'מה זוהה במסמך',
    suggestions: 'לקוחות מוצעים',
    noSuggestions: 'לא נמצא לקוח מתאים. ייתכן שזה לקוח חדש.',
    chooseOther: 'בחירת לקוח אחר',
    createNew: 'יצירת לקוח חדש מהמסמך',
    fields: 'פרטי המסמך לשמירה',
    learnAlias: 'לזכור את השם שבמסמך לזיהוי אוטומטי בעתיד',
    setCompanyNumber: 'להוסיף לכרטיס הלקוח את הח.פ מהמסמך',
    assign: 'שיוך ושמירה',
    ignore: 'לא רלוונטי',
    ignoreConfirm: 'לסמן את המסמך כלא רלוונטי? הוא לא יופיע בתור הבדיקה.',
    assigned: 'המסמך שויך ללקוח',
    warnings: 'שימו לב',
  },
  agent: {
    title: 'סוכן המייל',
    sub: 'חיבור תיבת הדואר, מעקב אחרי ייבוא המסמכים ממורנינג וכללי הזיהוי.',
    status: {
      ok: 'פעיל ומנטר',
      setup_required: 'נדרשת הגדרת חיבור למייל',
      not_connected: 'נדרש חיבור תיבת דואר',
      auth_error: 'ההרשאה לתיבת הדואר פגה',
      agent_offline: 'הסוכן אינו פועל',
      error: 'שגיאה בבדיקה האחרונה',
    },
    connect: 'חיבור Gmail',
    reconnect: 'חיבור מחדש',
    disconnect: 'ניתוק',
    disconnectConfirm: 'לנתק את תיבת הדואר? מסמכים חדשים לא ייובאו עד לחיבור מחדש.',
    syncNow: 'בדיקה עכשיו',
    lastChecked: 'בדיקה אחרונה',
    lastDetected: 'מסמך אחרון זוהה',
    lastImported: 'מסמך אחרון יובא',
    processed: 'מסמכים שעובדו',
    matched: 'שויכו אוטומטית',
    needsReview: 'ממתינים לבדיקה',
    errors: 'שגיאות',
    log: 'יומן עיבוד מסמכים',
    backfill: 'ייבוא היסטוריה',
    backfillBody: 'סריקת מיילים ישנים ממורנינג וייבוא המסמכים. מסמכים שכבר קיימים לא ייובאו פעמיים.',
    backfillSince: 'מתאריך',
    backfillStart: 'התחלת ייבוא',
    backfillRunning: 'ייבוא בתהליך',
    rules: 'כללי זיהוי',
    offlineHelp: 'הסוכן הוא תהליך נפרד שרץ ברקע. הפעילו אותו (npm run agent) או בדקו את השרת.',
  },
  finance: {
    title: 'גבייה ותזרים',
    sub: 'כמה כסף צפוי להיכנס בכל חודש לפי החשבוניות שהופקו ותנאי התשלום של כל לקוח.',
    expected: 'צפוי לחודש',
    received: 'התקבל',
    open: 'פתוח',
    overdue: 'באיחור',
    noDue: 'ללא תאריך תשלום',
    openInvoices: 'חשבוניות פתוחות',
    daysLate: 'ימי איחור',
  },
};
